/*
 * CompUK number motion — count-up + digit tick helpers.
 * Same safety contract as cuk-motion.js: reduced-motion and the theme editor
 * get the final value instantly, and server-rendered text is always the
 * correct final value, so nothing depends on this file running.
 *
 *   window.cukCount(el, to, opts)  — rAF count-up tween (easeOutCubic).
 *   window.cukTickSwap(el, text)   — swap text + replay the .is-tick digit
 *                                    animation (see .cuk-digit in app.css).
 *   [data-cuk-count-to="1234"]     — auto count-up on first visibility.
 */
(function () {
  var d = document;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var inEditor = window.Shopify && window.Shopify.designMode;
  var still = reduce || inEditor || !window.requestAnimationFrame;

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function fmt(el, n) {
    var prefix = el.getAttribute('data-cuk-count-prefix') || '';
    var suffix = el.getAttribute('data-cuk-count-suffix') || '';
    return prefix + Math.round(n).toLocaleString('en-GB') + suffix;
  }

  function cukCount(el, to, opts) {
    opts = opts || {};
    to = Number(to) || 0;
    var write = opts.format || function (n) { return fmt(el, n); };
    if (still) {
      el.textContent = write(to);
      return;
    }
    var duration = opts.duration || 900;
    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min(1, (ts - start) / duration);
      el.textContent = write(to * easeOutCubic(p));
      if (p < 1) window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
  }

  function cukTickSwap(el, text) {
    text = String(text);
    if (el.textContent === text) return;
    el.textContent = text;
    if (still) return;
    el.classList.remove('is-tick');
    void el.offsetWidth; // reflow so the animation replays
    el.classList.add('is-tick');
  }

  window.cukCount = cukCount;
  window.cukTickSwap = cukTickSwap;

  // Auto mode: tween [data-cuk-count-to] elements when they first become
  // visible. Skipped entirely when still — the rendered text is already final.
  if (still || !('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(function (entries) {
    for (var i = 0; i < entries.length; i++) {
      var e = entries[i];
      if (!e.isIntersecting) continue;
      io.unobserve(e.target);
      cukCount(e.target, e.target.getAttribute('data-cuk-count-to'));
    }
  }, { threshold: 0.4 });

  function scan() {
    var els = d.querySelectorAll('[data-cuk-count-to]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.__cukCounted) continue;
      el.__cukCounted = true;
      io.observe(el);
    }
  }

  function start() {
    scan();
    if ('MutationObserver' in window) {
      var queued = false;
      var mo = new MutationObserver(function () {
        if (queued) return;
        queued = true;
        window.requestAnimationFrame(function () {
          queued = false;
          scan();
        });
      });
      mo.observe(d.body, { childList: true, subtree: true });
    }
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start);
  else start();
})();
